<template>
  <div class="cart-item">
    <div class="cart-item__left">
      <!--      <CheckboxComponent :checked="isCheck" @change="changeActiveCartItems(data)" />-->
      <div class="cart-item__image">
        <ImgComponent :head_img="data.product.preview_img" />
      </div>
      <div class="cart-item__info">
        <div class="cart-item__title">
          <span>{{ data.product.title }}</span>
          <FavoriteComponent :product="data.product" />
        </div>
        <span class="cart-item__price-one"> цена за 1 штуку: {{ data.product.price_retail }} ₽</span>
      </div>
    </div>
    <div class="cart-item__right">
      <div class="cart-item__counter">
        <button
          @click.prevent="change(count - 1)"
          :disabled="count === 1"
          class="btn cart-item__counter-plus"
        >
          <IconComponent name="minus" />
        </button>
        <span> {{ count ? count : "" }} </span>
        <button @click.prevent="change(count + 1)" class="btn cart-item__counter-minus">
          <IconComponent name="plus" />
        </button>
      </div>
      <div class="cart-item__price">
        <div class="cart-item__price-info">
          <span class="cart-item__price-new">{{ data.product.price_retail * count }} ₽</span>
          <span v-show="data.product.price_without_discount" class="cart-item__price-old"
            ><span>{{ data.product.price_without_discount * count }}</span> <span>₽</span></span
          >
        </div>
        <div class="cart-item__remove-from-cart" @click.prevent="change(0)">
          <span>Убрать из корзины</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
import IconComponent from "components/IconComponent.vue";
import { manageCartItem } from "../../../utils";
import FavoriteComponent from "components/FavoriteComponent.vue";
export default {
  name: "CartItemComponent",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      count: null,
      check: this.isCheck,
    };
  },
  created() {
    this.count = this.data.quantity;
  },
  methods: {
    manageCartItem,
    change(value) {
      this.count = value;
      manageCartItem({
        store: this.$store,
        apollo: this.$apollo.provider.defaultClient,
        product: this.data.product,
        count: this.count,
      });
    },
    changeActiveCartItems(product) {
      if (this.activeCartItems.find((item) => item.product.id === product.product.id)) {
        this.$store.state.auth.activeCartItems = this.$store.state.auth.activeCartItems.filter(
          (item) => item.product.id !== product.product.id
        );
      } else {
        this.$store.state.auth.activeCartItems = [product, ...this.$store.state.auth.activeCartItems];
      }
    },
  },
  computed: {
    activeCartItems() {
      return this.$store.state.auth.activeCartItems;
    },
    isCheck() {
      return !!this.activeCartItems.find((item) => item.product.id === this.data.product.id);
    },
  },

  components: {
    FavoriteComponent,
    IconComponent,
    CheckboxComponent,
    ImgComponent,
  },
};
</script>

<style lang="stylus">
.cart-item {
  display flex
  background var(--white)
  border-radius 20px
  padding 20px 30px
  justify-content space-between

  +below(1024px) {
    flex-direction column
  }

  &__left {
    display flex
    //align-items center
    gap 30px
  }

  &__right {
    padding-top 30px
    display flex
    gap 30px
    align-items: flex-start;
    +below(1024px) {
      flex-direction column-reverse
    }
  }

  &__info {
    display flex
    flex-direction column
    gap 8px
  }

  &__counter {
    display flex
    gap 10px
    align-items center

    span {
      font-weight: 400;
      font-size: 1.500em
      line-height: 28px;
      color: var(--gray-5);
    }
  }

  &__counter-plus, &__counter-minus {
    width 30px
    height 30px
    background var(--white)
    border 1px solid var(--gray-3)
    border-radius 5px

    .icon {
      width 20px
      height 20px

      svg path {
        fill var(--gray-6)
      }
    }
  }

  &__price {
    display flex
    align-items flex-end
    flex-direction column
    gap 30px
  }

  &__price-info {
    display flex
    justify-content space-between
    align-items flex-end
    gap 20px
  }

  &__remove-from-cart {
    font-weight: 400;
    font-size: 1rem
    line-height: 19px;
    color: var(--red-2)
    cursor pointer

    +below(1024px) {
      display none
    }
  }

  &__price-new {
    font-weight: 400;
    font-size: 1.500em
    line-height: 28px;
    text-transform: uppercase;
  }

  &__price-old {
    display flex
    gap 2px
    font-weight: 400;
    font-size: 1rem
    line-height: 19px;
    text-transform: uppercase;
    color: var(--gray-2)

    span:nth-child(1) {
      text-decoration-line: line-through;
    }
  }

  &__image {
    width 145px
    height 145px

    img {
      width 100%
      height 100%
      object-fit cover
    }
  }

  &__title {
    padding-top 30px
    align-self flex-start
    font-weight: 400;
    font-size: 1.500em;
    line-height: 28px;
    text-transform: uppercase;
    display: flex
    gap 12px

    & .favorite {
      width 25px
      height 25px
    }
  }


}
</style>
